import { Component, Input, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ImagesService } from '../../_services/images.service';
import { NotificationService } from 'app/_services/notification.service';

import { ImageTableComponent } from '../ag-grid/image-table.component';
import { ImageLinksComponent } from '../ag-grid/image-links.component';

@Component({
  selector: 'app-image-list',
  templateUrl: './imagelist.component.html',
  styleUrls: ['./imagelist.component.css'],
  providers: [ImageTableComponent, ImageLinksComponent],
})
export class ImageListComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() storeId: any;
  @Input() allowSelect: any;

  @Output() imageDelete = new EventEmitter();
  @Output() imageSelect = new EventEmitter();

  gridOptions;

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
  };

  images: any[] = [];
  columnDefs = [];

  private gridApi;
  private gridColumnApi;

  constructor(
    public _imagesService: ImagesService,
    public notificationService: NotificationService
  ) {}

  ngOnInit() {
    console.log('store id', this.storeId);

    this.gridOptions = {
      accentedSort: true,
      rowHeight: 150,
      suppressCellSelection: true,
      context: {
        componentParent: this,
      },
    };

    this.columnDefs = [
      {
        headerName: 'Image',
        filter: false,
        sortable: false,
        maxWidth: 200,
        cellRendererFramework: ImageTableComponent,
        cellRendererParams: {},
      },
      { headerName: 'Name', field: 'name' },
      // { headerName: 'Title', field: 'title' },

      {
        headerName: 'Actions',
        filter: false,
        sortable: false,
        cellRendererFramework: ImageLinksComponent,
        cellRendererParams: {
          allowSelect: this.allowSelect,
        },
      },
    ];
  }

  quickFilterSearch(data) {
    if (data) {
      console.log('quickFilterSearch', data);
      this.gridApi.setQuickFilter(data);
    } else {
      this.gridApi.setQuickFilter('');
    }
  }

  deleteImage(image) {
    this._imagesService.deleteImage(image, this.storeId).subscribe((data: any) => {
      this.imageDelete.emit(image);
      this.notificationService.notify(
        'success',
        'Image Deleted',
        'Image has successfully been deleted',
        'top',
        'right'
      );
    });
  }

  selectImage(image) {
    this.imageSelect.emit(image);
  }

  ngOnChanges(changes: any) {
    const imageData = changes.data.currentValue;
    this.images = [];

    imageData.forEach((element) => {
      const obj = {
        id: element.id,
        name: element.name,
        title: element.title,
        imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
        src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
        thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
      };
      this.images.push(obj);
    });

    console.log('images', this.images);
  }

  onGridReady(params) {
    console.log('onGridReady');
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  firstDataRendered(e) {
    console.log('firstDataRendered');
    // this.autoSizeAll(false);
    this.sizeToFit();
  }

  sizeToFit() {
    this.gridApi.sizeColumnsToFit();
  }

  autoSizeAll(skipHeader) {
    const allColumnIds = [];
    this.gridColumnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/imagelist/imagelist.component.ts